import { useEffect, useState } from "react";
import axios from "axios";
import { api_v3_get_matches_by_player_and_tournament } from "../utils/constants";

const usePlayerRegularDivision = (playerId, tournamentId) => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!playerId || !tournamentId) return;
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        const url = api_v3_get_matches_by_player_and_tournament(
          playerId,
          tournamentId
        );
        const res = await axios.get(url);
        if (cancelled) return;
        const matches = Array.isArray(res.data) ? res.data : [];
        const regular = matches.find(
          (m) => m.phase === "REGULAR_LEAGUE" && m.divisionId
        );
        if (regular) {
          setInfo({
            divisionId: regular.divisionId,
            divisionName: regular.divisionName,
            groupId: regular.groupId,
            groupName: regular.groupName,
          });
        } else {
          setInfo(null);
        }
      } catch {
        if (!cancelled) setInfo(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [playerId, tournamentId]);

  return { info, loading };
};

export default usePlayerRegularDivision;
